import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=03bfe564&scoped=true"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=03bfe564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bfe564",
  null
  
)

export default component.exports